<template>
    <div class="contact-custom-attribute__row">
        <div class="contact-custom-attribute__atribute">
            <label class="contact-custom-attribute__label" v-tooltip:overflow="attribute.key">{{
                attribute.key
            }}</label>
            <small class="contact-custom-attribute__date">Added {{ attributeCreatedAt }}</small>
        </div>

        <div class="contact-custom-attribute__atribute">
            <label class="contact-custom-attribute__label" v-tooltip:overflow="attribute.value">{{
                attribute.value
            }}</label>
            <small class="contact-custom-attribute__date">Updated {{ attributeUpdatedAt }} </small>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { shortDateTime } from '../../../utils/date';
import { VxTooltip as VTooltip } from '@voxie/frontend-components-v3';

const props = defineProps({
    attribute: {
        type: Object,
        required: true,
    },
});

const attributeCreatedAt = computed(() => shortDateTime(props.attribute.created_at));
const attributeUpdatedAt = computed(() => shortDateTime(props.attribute.updated_at));
</script>

<style lang="scss">
.contact-custom-attribute__row {
    display: grid;
    grid-template-columns: 50% 50%;
    font-family: var(--font-open-sans);

    &:nth-of-type(odd) {
        background-color: var(--color-background);
    }
}

.contact-custom-attribute__atribute {
    display: flex;
    flex-direction: column;
    padding: 16px;
}

.contact-custom-attribute__label {
    font-size: 0.9375rem; // 15px;
    font-weight: var(--weight-semibold);
    color: var(--color-grey);
    margin: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.contact-custom-attribute__date {
    font-size: 0.75rem; // 12px;
    font-weight: var(--weight-regular);
    color: var(--color-grey-600);
}
</style>
